import React, { useMemo, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { useMemoizedFn } from 'ahooks';
import { Button, DialogPlugin, Form, Input, Select, Table, Tag } from 'tdesign-react';
// import { isEmpty } from 'lodash';
import { useSearchParams } from 'react-router-dom';
import { isEmpty } from 'lodash';
import ShadowCard from '@/components/ShadowCard';
import { fetchTenantOptions } from '@/slices/kopTopicSlice';
import useTable from '@/hooks/useTable';
import {
  renderByte,
  renderDateTime,
  renderNum,
  renderNumRate,
  sleep,
  toTsOptions,
} from '@/utils/common';
import ColTip from '@/components/Tip';
import SvgIcon from '@/components/SvgIcon';
// import PermWrapper from '@/components/PermWrapper';
import SystemSwitchAppend from '@/components/Cluster/SystemSwitchAppend';
import {
  getTopicListServerPaginate,
  getNamespacesOptions,
  // delTopicBatch,
  getTopicChartData,
  delTopicBatch,
} from '@/services/kopTopicService';
import PermWrapper from '@/components/PermWrapper';
import { getCurrentCluster } from '@/pages/Layout/MenuLayout/CulsterAddon';
import DisableBuriedPermWrapper from '@/components/DisableWrapper/DisableBuriedPermWrapper';
import Dashboard from './Dashboard';
import FormModal from './FormModal';
import Detail from './Detail';
// import Detail from './Detail';

const { FormItem } = Form;

function Body({ fetchTenantOptions, clusterName, tenantOptions, currentCluster }) {
  const [formVisible, setFormVisible] = useState(false);
  const [nsOptions, setNsOptions] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchParams] = useSearchParams();
  const [visible, setVisible] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [systemTopic, setSystemTopic] = useState(false);
  const isKafka = currentCluster?.clusterType === 'kafka';

  // 查询初始化
  const initialData = useMemo(
    () => ({
      tenant: searchParams.get('tenant'),
      namespace: searchParams.get('namespace'),
      topic: searchParams.get('topic'),
    }),
    [searchParams],
  );

  const columns = [
    {
      colKey: 'row-select',
      title: '多选',
      type: 'multiple',
      fixed: 'left',
      width: 46,
    },
    {
      colKey: 'topic',
      title: 'Topic',
      width: 280,
      fixed: 'left',
      sorter: true,
      cell: ({ row }) => (
        <TopicRow>
          {row.systemTopic && (
            <Tag style={{ marginRight: 6 }} theme='danger'>
              system
            </Tag>
          )}
          <Detail topic={row.topic} clusterName={clusterName} onRefresh={doRefresh} />
        </TopicRow>
      ),
    },
    {
      colKey: 'topicPartitionCount',
      width: 110,
      title: (
        <ColTip
          content={
            <>
              <strong>分区个数</strong>
              <li>0代表该Topic为非分区。</li>
              <li>n代表实际分区个数。</li>
            </>
          }
        >
          分区
        </ColTip>
      ),
      sorter: true,
    },
    {
      colKey: 'app',
      title: '所属应用',
      width: 120,
      defaultHide: true,
      ellipsis: true,
    },
    {
      colKey: 'replicationCount',
      title: '副本数',
      width: 120,
      sorter: true,
    },
    {
      colKey: 'messageSize',
      title: '消息大小',
      width: 120,
      sorter: true,
      cell: renderByte,
    },
    {
      colKey: 'createByPlatform',
      sorter: true,
      defaultHide: true,
      title: (
        <ColTip
          content={
            <>
              <strong>平台创建</strong>
              <li>是，代表为管控台创建。</li>
              <li>否，代表由系统自动创建，或者通过Pulsar admin命令创建。</li>
            </>
          }
        >
          平台创建
        </ColTip>
      ),
      cell: ({ row }) => (row.createByPlatform ? '是' : '否'),
      width: 130,
    },
    {
      title: '生产速率',
      colKey: 'rateIn',
      sortType: 'all',
      sorter: true,
      width: 120,
      cell: renderNumRate,
    },
    {
      title: '消费速率',
      colKey: 'rateOut',
      sortType: 'all',
      sorter: true,
      width: 120,
      cell: renderNumRate,
    },
    {
      title: '保存时间(分钟)',
      colKey: 'retention',
      sorter: true,
      width: 160,
    },
    {
      title: (
        <ColTip
          content={
            <>
              <strong>积压条数</strong>
              <li>获取消费最慢的订阅者积压值。</li>
            </>
          }
        >
          积压条数
        </ColTip>
      ),
      colKey: 'backlog',
      sorter: true,
      defaultSort: 'desc',
      cell: renderNum,
      width: 140,
    },
    {
      title: '创建时间',
      colKey: 'createTime',
      sorter: true,
      defaultHide: true,
      cell: renderDateTime,
      width: 180,
    },
    {
      colKey: 'updateTime',
      cell: renderDateTime,
      sorter: true,
      title: <ColTip content='非实时，有分钟级延迟'>采集时间</ColTip>,
      width: 180,
    },
    {
      colKey: 'option',
      title: '操作',
      fixed: 'right',
      align: 'center',
      cell: ({ row }) => (
        <Icon
          type='presentation-chart-line'
          onClick={() => {
            setVisible(true);
            setCurrentRow(row);
          }}
        />
      ),
      width: 60,
    },
  ];

  const loadData = useMemoizedFn(async (params = {}) => {
    setSelectedRowKeys([]);
    const { data } = await getTopicListServerPaginate({
      clusterName,
      containSystemTopic: systemTopic,
      ...params,
    });
    setData(data.items, data.count);
  });

  const onSystemSwitch = async (isContainSystemTopic) => {
    setSystemTopic(isContainSystemTopic);
    await sleep(30);
    doSearch(null, true);
  };
  // 切换tenant
  const tenantChange = (val) => {
    setNsOptions([]);
    form.setFieldsValue({ namespace: null });
    if (val) {
      loadNSOptions(val);
    }
  };

  const { setData, header, config, doSearch, doRefresh, form } = useTable({
    columns,
    onSearch: loadData,
    search: (
      <>
        {!isKafka && (
          <>
            <FormItem name='tenant'>
              <Select
                options={toTsOptions(tenantOptions)}
                onChange={tenantChange}
                placeholder='请选择租户'
                clearable
              />
            </FormItem>
            <FormItem name='namespace'>
              <Select
                options={toTsOptions(nsOptions)}
                clearable
                filterable
                placeholder='请选择命名空间'
                popupProps={{ overlayInnerStyle: { width: 'auto', minWidth: 200 } }}
              />
            </FormItem>
          </>
        )}
        <FormItem name='topic'>
          <Input placeholder='请输入Topic' clearable />
        </FormItem>
      </>
    ),
    append: <SystemSwitchAppend value={systemTopic} onChange={onSystemSwitch} />,
    operators: (
      <>
        <DisableBuriedPermWrapper resource='kop:topic:list:deletes'>
          <Button
            theme='danger'
            onClick={() => {
              const confirm = DialogPlugin.confirm({
                theme: 'danger',
                header: '警告',
                body: '确定删除所选内容？',
                confirmBtn: {
                  theme: 'danger',
                  content: '删除',
                },
                onClose: () => confirm.destroy(),
                onConfirm: async () => {
                  await delTopicBatch({
                    clusterName,
                    topics: selectedRowKeys,
                  });
                  doRefresh();
                  confirm.destroy();
                },
              });
            }}
            disabled={isEmpty(selectedRowKeys)}
          >
            批量删除
          </Button>
        </DisableBuriedPermWrapper>
        <PermWrapper resource='kop:topic:list:create'>
          <Button
            theme='primary'
            onClick={() => {
              setFormVisible(true);
            }}
          >
            创建Topic
          </Button>
        </PermWrapper>
      </>
    ),
    remote: true,
    rowClassName: ({ row: { deleted } }) => (deleted ? 'is-deleted' : ''),
  });

  const loadNSOptions = useMemoizedFn(async (tenantVal) => {
    const options = await getNamespacesOptions({
      clusterName,
      tenant: tenantVal,
    });
    setNsOptions(options);
  });

  const doInit = useMemoizedFn(async () => {
    setSystemTopic(false);
    form.reset();
    if (!isKafka) {
      // 加载租户下拉
      fetchTenantOptions({
        clusterName,
        type: 'kop_tenant',
      });
      await sleep(30);
    }

    // 有初始化条件
    if (searchParams.size > 1) {
      // 如果初始化有租户，加载ns下拉
      if (initialData.tenant) {
        loadNSOptions(initialData.tenant);
      }
      await doSearch(initialData);
      form.setFieldsValue(initialData);
    } else {
      doSearch();
    }
  });

  useEffect(() => {
    if (currentCluster) {
      doInit();
    }
  }, [currentCluster, doInit]);

  const handleClose = () => {
    setVisible(false);
  };

  const modalClose = (refresh) => {
    setFormVisible(false);
    if (refresh) {
      doRefresh();
    }
  };

  const onSelectChange = (value) => {
    setSelectedRowKeys(value);
  };

  return (
    <Root>
      {header}
      <Table
        {...config}
        rowKey='topic'
        selectedRowKeys={selectedRowKeys}
        onSelectChange={onSelectChange}
      />
      <Dashboard
        clusterName={clusterName}
        visible={visible}
        detail={currentRow}
        getChartsData={(params) =>
          getTopicChartData({
            clusterName,
            topicName: currentRow.topic,
            ...params,
          })
        }
        handleClose={handleClose}
      />
      <FormModal visible={formVisible} clusterName={clusterName} handleClose={modalClose} />
    </Root>
  );
}

export default connect(
  (state) => ({
    tenantOptions: state.kopTopic.tenantOptions,
    currentCluster: getCurrentCluster(state.kopCluster.allList),
  }),
  {
    fetchTenantOptions,
  },
)(Body);

const Root = styled(ShadowCard)`
  flex: 1;
  margin-top: 12px;
  .is-deleted {
    background-color: var(--td-error-color-1);
  }
`;

const Icon = styled(SvgIcon)`
  cursor: pointer;
  color: #194dff;
`;

const TopicRow = styled.div`
  word-break: break-all;
`;
